import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom'; 
import { Box } from '@mui/material';
import AppRouter from './router/AppRouter';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from "./components/ScrollToTop";
import { DynamicThemeProvider } from './styles/DynamicThemeProvider';

function App() {
  return (
    <DynamicThemeProvider>
      <Router>
        <ScrollToTop />
        <Header />
        <Box sx={{ minHeight: 'calc(50vh)' }}>
          <AppRouter />
        </Box>
        <Footer />
      </Router>
    </DynamicThemeProvider>
  );
}

export default App;